<template lang="html">
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-form @submit.prevent="submit()">
        <d-form-row>
          <d-col md="full" lg="8" xl="4" class="form-group">
            <label for="feLogo">Logo</label>
            <div class="custom-file mb-3">
              <d-form-input
                type="text"
                id="feLogo"
                class="feLogo"
                placeholder="Path do logo"
                v-model="model.logo"
              />
            </div>
          </d-col>
        </d-form-row>

        <d-form-row class="mb-3">
          <d-col md="full" lg="8" xl="4" class="form-group">
            <label for="feDistributorNational">
              Representante Nacional padrão
            </label>
            <autocomplete
              ref="resellerNational"
              placeholder="Representante nacional"
              parameter="national"
              :items="resellers"
              item-show="name"
              :on-input="onInput"
              :on-select="saveDistributor"
            ></autocomplete>
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="full" lg="8" xl="4" class="form-group">
            <label for="feRegional">
              Enviar distribuidor no email da lead para as regiões:
            </label>

            <d-checkbox
              v-for="(region, key) in regionalOptions"
              :key="key"
              style="margin-bottom: 15px; margin-top: 10px"
              toggle
              v-model="model.regional[region.value]"
            >
              {{ region.text }}
            </d-checkbox>
          </d-col>
        </d-form-row>

        <settings-lead-score :model="model" />

        <d-form-row>
          <d-button type="submit" class="btn-primary">Salvar</d-button>
        </d-form-row>
      </d-form>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { regionalOptions } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import DistributorService from '_services/rest/modules/distributor';
import SettingsService from '_services/rest/modules/settings';
import SettingsLeadScore from './score/SettingsLeadScore.vue';
import { _LOAD_MODEL_SETTING_, SETTINGS } from './SettingsModel';

export default {
  name: 'settings-form',
  components: {
    Autocomplete,
    SettingsLeadScore,
  },
  data() {
    return {
      model: { ...SETTINGS },
      regionalOptions,
      resellers: [],
    };
  },
  methods: {
    ...mapActions(['activeAlert']),
    onInput(search) {
      const params = {
        search,
        skip: 0,
        take: 10,
        page: 1,
      };
      DistributorService.getList(params).then(response => {
        this.resellers = response.list;
      });
    },
    loadDistributor(reseller) {
      if (this.$refs.resellerNational && reseller) {
        this.$refs.resellerNational.$refs.input.value = reseller.name;
      }
    },
    save() {
      delete this.model.reseller;
      SettingsService.saveOptions(this.model, 'settings')
        .then(() =>
          this.activeAlert({
            message: 'Variáveis salvas com sucesso',
            theme: 'success',
          })
        )
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        })
        .finally((this.loading = false));
    },
    saveDistributor(reseller) {
      this.model.resellerNational = reseller.id.toString();
    },
    submit() {
      this.loading = true;
      return this.save();
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...newValue };
      this.loadDistributor(newValue.reseller);
    });
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_SETTING_);
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
